import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AuthenticationService } from '../login/auth.service';
import { PrivacyPolicyDTO } from 'app/model/privacy-policy.enum';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-privacy-policy-popup',
  templateUrl: './privacy-policy-popup.component.html',
  styleUrls: ['./privacy-policy-popup.component.scss'],
})
export class PrivacyPolicyPopupComponent implements OnInit {
  parsedJson: any;
  checkboxvalue: boolean = false;
  constructor(
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private dialogRef: MatDialogRef<PrivacyPolicyPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {
    // if (this.data != null) {
    //   this.dialogRef.close(true);
    // } else {
    // }
  }
  privacyPolicyDTO: PrivacyPolicyDTO = new PrivacyPolicyDTO();

  ngOnInit() {}

  accept(): void {
    this.privacyPolicyDTO.deviceDetails = navigator.userAgent;
    this.privacyPolicyDTO.policyLanguage = navigator.language;
    this.privacyPolicyDTO.userId = this.data[0].userDetails.userId;
    this.privacyPolicyDTO.email = this.data[0].userDetails.emailAddress;
    this.privacyPolicyDTO.domain = this.data[0].userDetails.domain;
    this.privacyPolicyDTO.userAction = 'Accepted';
    // this.data.component.onDeleteClick();
    this.authenticationService.insertprivacyPolicy(this.privacyPolicyDTO).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.dialogRef.close(true);
      },
      error => {
        // this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
  close(): void {
    this.dialogRef.close(false);
  }
}
